module.exports = __webpack_public_path__ + "img/cast.a8939011.svg";